module.exports = __webpack_public_path__ + "img/cadee17.jpg";